import { Card, Divider, Grid, Icon, Menu, MenuItem } from "@mui/material";
import SoftBadge from "components/SoftBadge";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { itemArrow } from "examples/Sidenav/styles/sidenavItem";
import { useState } from "react";
import ApiService from "services/ApiService";
import Helpers from "utils/Helpers";

function TableCard({ tableId, companyId, tableName, total, count, startDate }) {
  const [showItems, setShowItems] = useState(false);
  const [menuItem, setMenuItem] = useState(null);
  let [tableItems, setTableItems] = useState([]);

  const closeTableContent = () => {
    setShowItems(false);
  };

  const openTableContent = async (e) => {
    const response = await ApiService.getData(
      `/api/v1/invoices/open-tables?tableId=${tableId}&companyId=${companyId}`
    );
    if (!response) return;
    setTableItems(response.data.data);
    setMenuItem(e.currentTarget);
    setShowItems(true);
  };

  return (
    <Grid item md={3} xs={6}>
      <SoftBox mb={3} m={2}>
        <Card>
          <SoftBox p={3}>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <SoftTypography
                variant="h5"
                fontWeight="medium"
                color="info"
                textTransform="capitalize"
                textGradient
              >
                Τραπέζι: {tableName}
              </SoftTypography>
              <SoftTypography
                color="secondary"
                title={`Λεπτομέρειες ${tableName}`}
                onClick={openTableContent}
                sx={{
                  width: "16px",
                  cursor: "pointer",
                }}
              >
                <Icon fontSize="default">more_vert</Icon>
              </SoftTypography>
              <Menu
                anchorEl={menuItem}
                anchorOrigin={{ vertical: "center", horizontal: "center" }}
                transformOrigin={{ vertical: "center", horizontal: "center" }}
                open={showItems}
                onClose={closeTableContent}
                keepMounted
              >
                {tableItems.map((item) => (
                  <MenuItem key={item.id}>
                    {Helpers.formatDateToNormal(item.requestDate)} | {item.series} {item.aa} |{" "}
                    {item.totalGrossAmount.toFixed(2)} €
                  </MenuItem>
                ))}
              </Menu>
            </SoftBox>

            <SoftBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
              <SoftBox component="li" display="flex" flexDirection="column">
                <SoftBox display="flex" justifyContent="space-between" alignItems="center">
                  <SoftTypography variant="body2" color="text">
                    Ανοιχτό από:
                  </SoftTypography>
                  <SoftTypography variant="body2" color="text">
                    {startDate}
                  </SoftTypography>
                </SoftBox>
                <Divider />
              </SoftBox>
              <SoftBox component="li" display="flex" flexDirection="column">
                <SoftBox display="flex" justifyContent="space-between" alignItems="center">
                  <SoftTypography variant="body2" color="text">
                    Υπόλοιπο:
                  </SoftTypography>
                  <SoftBadge
                    variant="contained"
                    color="error"
                    size="md"
                    badgeContent={total.toFixed(2) + " €"}
                    container
                  />
                </SoftBox>
                <Divider />
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </Card>
      </SoftBox>
    </Grid>
  );
}

export default TableCard;
